/**
 * Mobile product galleries use the browser's own horizontal scrolling.
 * Splide's drag layer was snapping on a short flick and resizing the
 * frame mid-gesture, which made swipes feel like they skipped.
 */
(function () {
  var mq = window.matchMedia('(max-width: 1023px)');
  var watched = new WeakSet();

  function gridlineWidth() {
    return (
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--gridline-width'),
        10
      ) || 0
    );
  }

  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);

    var splide = null;
    var list = null;
    var track = null;
    var enabled = false;
    var settling = false;
    var settleTimer = 0;

    function productData() {
      var productRoot = root.closest('[data-product-root]');
      var stack = productRoot && productRoot._x_dataStack;
      return stack && stack[0];
    }

    function slides() {
      return Array.prototype.slice.call(
        list.querySelectorAll(':scope > .splide__slide')
      );
    }

    function mediaHeight(slide) {
      if (!slide) return 0;
      var media = slide.querySelector('[data-product-single-media-wrapper]');
      return (media || slide).offsetHeight;
    }

    function applyHeight(px, animate) {
      track.style.transition = animate
        ? 'max-height 220ms cubic-bezier(0.22, 1, 0.36, 1)'
        : 'none';
      track.style.maxHeight = Math.round(px + gridlineWidth()) + 'px';
    }

    function syncHeight(animate) {
      var width = list.clientWidth;
      if (!width) return;
      var items = slides();
      var progress = list.scrollLeft / width;
      var index = Math.min(items.length - 1, Math.max(0, Math.floor(progress + 0.001)));
      var frac = progress - index;
      var current = mediaHeight(items[index]);
      var next = mediaHeight(items[index + 1]) || current;
      var between = frac > 0.02 && frac < 0.98;
      applyHeight(between ? Math.max(current, next) : frac >= 0.98 ? next : current, animate && !between);
    }

    function indexFromScroll() {
      var width = list.clientWidth || 1;
      return Math.max(0, Math.min(slides().length - 1, Math.round(list.scrollLeft / width)));
    }

    function scrollToIndex(index, smooth) {
      var slide = slides()[index];
      if (!slide) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollTo({
        left: slide.offsetLeft,
        behavior: smooth && !reduce ? 'smooth' : 'auto'
      });
    }

    function onMove(newIndex) {
      if (settling) return;
      scrollToIndex(newIndex, true);
    }

    function settle() {
      if (!enabled) return;
      syncHeight(true);
      if (!splide || splide.index === indexFromScroll()) return;
      settling = true;
      splide.go(indexFromScroll());
      settling = false;
    }

    function syncArrows() {
      if (!list) return;
      var index = indexFromScroll();
      var last = slides().length - 1;
      var prev = root.querySelector('.splide__arrow--prev');
      var next = root.querySelector('.splide__arrow--next');
      if (prev && prev.disabled !== (index <= 0)) prev.disabled = index <= 0;
      if (next && next.disabled !== (index >= last)) next.disabled = index >= last;
    }

    function onScroll() {
      syncHeight(false);
      syncArrows();
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 90);
    }

    function onScrollEnd() {
      window.clearTimeout(settleTimer);
      settle();
    }

    function enable() {
      if (enabled || !mq.matches) return;
      var data = productData();
      splide = data && data.splide;
      if (!splide || !splide.root) return;
      if (
        window.Splide &&
        splide.state &&
        window.Splide.STATES &&
        splide.state.is(window.Splide.STATES.DESTROYED)
      ) {
        return;
      }

      list = root.querySelector('.splide__list');
      track = root.querySelector('.splide__track');
      if (!list || !track || slides().length < 2) return;

      try {
        splide.Components.Drag.disable(true);
      } catch (error) {}

      root.classList.add('is-native-scroll');
      root.dataset.nativeScroll = 'on';
      scrollToIndex(splide.index || 0, false);
      syncHeight(false);

      list.addEventListener('scroll', onScroll, { passive: true });
      list.addEventListener('scrollend', onScrollEnd);
      splide.on('move', onMove);
      splide.on('moved', syncArrows);
      splide.on('destroy', disable);
      var arrows = root.querySelector('.splide__arrows');
      if (arrows) {
        new MutationObserver(syncArrows).observe(arrows, {
          attributes: true,
          subtree: true,
          attributeFilter: ['disabled']
        });
      }
      syncArrows();
      enabled = true;

      Array.prototype.forEach.call(list.querySelectorAll('img'), function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            syncHeight(false);
          }, { once: true });
        }
      });
    }

    function disable() {
      if (!enabled) return;
      enabled = false;
      root.classList.remove('is-native-scroll');
      if (root.dataset) delete root.dataset.nativeScroll;
      if (list) {
        list.removeEventListener('scroll', onScroll);
        list.removeEventListener('scrollend', onScrollEnd);
      }
      if (track) track.style.transition = '';
      try {
        splide.off('move', onMove);
      } catch (error) {}
      try {
        splide.Components.Drag.disable(false);
      } catch (error) {}
    }

    function tick() {
      if (mq.matches) enable();
      else disable();
    }

    new MutationObserver(tick).observe(root, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (mq.addEventListener) mq.addEventListener('change', tick);
    else if (mq.addListener) mq.addListener(tick);

    tick();
  }

  function scan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.splide--product'),
      watch
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
